import React from "react";
import { Link } from "react-router-dom";

type Product = {
  _id: string;
  title: string;
  price: number;
  images: string[];
  colors: string[];
};

export default function ProductCard({ product }: { product: Product }) {
  return (
    <div className="p-4 flex flex-col items-center w-80 border rounded-md shadow-sm hover:shadow-md transition">
      <Link to={`/product/${product._id}`} className="w-full">
        <img
          src={product.images[0]}
          alt={product.title}
          className="w-full h-64 object-cover rounded-md mb-3 hover:scale-105 transition-transform duration-300"
          loading="lazy"
        />
      </Link>

      <div className="text-center text-sm font-semibold">{product.title}</div>
      <div className="mt-2 text-sm font-medium">{product.price}€</div>

      <div className="flex items-center gap-2 mt-3">
        {product.colors.map((color, i) => (
          <div
            key={i}
            className={`w-4 h-4 rounded-full border ${
              color === "white" ? "bg-white border-gray-400" : `bg-black` // Color circle here
            }`}
          ></div>
        ))}
      </div>
    </div>
  );
}
